import React, { Component } from "react";

import './AutoTruncateTextLabel.css'

export class AutoTruncateTextLabel extends Component {
    render() {
        return (
            <span className="autoTruncateTextLabel" style={{
                ...this.props.data.style
            }} title={this.props.data.text}>
                {this.props.data.text}
            </span>
        );
    }
}
    